import sal from "sal.js";

export const filtersNews = () => {
  const filtersListNews = document.querySelector('[data-filters-list="news"]');
  const cardsContainer = document.querySelector(".js-news-cards");

  if (!filtersListNews || !cardsContainer) {
    return;
  }

  const filterItemsNews = filtersListNews.querySelectorAll("[data-filter]");
  const activeFilters = {
    category: "",
  };
  const state = {
    page: Number(cardsContainer.getAttribute("data-news-page") || 1),
    hasMore: cardsContainer.getAttribute("data-news-has-more") === "1",
    isLoading: false,
  };

  const sentinel = document.createElement("div");
  sentinel.className = "js-news-load-sentinel";
  sentinel.setAttribute("aria-hidden", "true");
  sentinel.style.height = "1px";
  cardsContainer.insertAdjacentElement("afterend", sentinel);

  const init = () => {
    applyActiveFilters();
    initInfiniteScroll();
    bind();
  };

  const bind = () => {
    filterItemsNews.forEach((item) => {
    
      item.addEventListener("click", function (evt) {
        evt.preventDefault();
        const nextCategory = this.getAttribute("data-filter") || "";
        if (activeFilters.category === nextCategory) {
          return;
        }

        updateActiveFilter("category", nextCategory);
        applyActiveFilters();
        loadPosts({ page: 1, replace: true });
      });
    });
  };

  const updateActiveFilter = (filterType, filterValue) => {
    activeFilters[filterType] = filterValue;
  };

  const applyActiveFilters = () => {
    filterItemsNews.forEach((item) => {
      const filterValue = activeFilters.category;
      if (item.getAttribute("data-filter") === filterValue) {
        item.classList.add("is-current");
      } else {
        item.classList.remove("is-current");
      }
    });
  };

  const getJsonUrl = (page) => {
    const url = new URL(window.location.href);
    const cleanPath = url.pathname.replace(/\/$/, "");
    url.pathname = cleanPath ? `${cleanPath}.json` : "/.json";
    url.search = "";
    url.searchParams.set("page", String(page));

    if (activeFilters.category) {
      url.searchParams.set("category", activeFilters.category);
    }

    return url.toString();
  };

  const loadPosts = async ({ page, replace = false }) => {
    if (state.isLoading) {
      return;
    }

    state.isLoading = true;

    try {
      const response = await fetch(getJsonUrl(page), {
        headers: {
          "X-Requested-With": "XMLHttpRequest",
        },
      });

      if (!response.ok) {
        throw new Error(`Unexpected response status: ${response.status}`);
      }

      const payload = await response.json();
      if (typeof payload.html !== "string") {
        throw new Error("Invalid blog payload format");
      }

      if (replace) {
        cardsContainer.innerHTML = payload.html;
      } else {
        cardsContainer.insertAdjacentHTML("beforeend", payload.html);
      }

      sal({
        threshold: 0.01,
        once: true,
      });

      state.page = page;
      state.hasMore = payload.hasMore === true || payload.hasMore === 1 || payload.hasMore === "1";
      cardsContainer.setAttribute("data-news-page", String(state.page));
      cardsContainer.setAttribute("data-news-has-more", state.hasMore ? "1" : "0");
    } catch (error) {
      console.error("Could not load more blog posts", error);
    } finally {
      state.isLoading = false;
    }
  };

  const initInfiniteScroll = () => {
    if (!("IntersectionObserver" in window)) {
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting || !state.hasMore || state.isLoading) {
            return;
          }

          loadPosts({ page: state.page + 1 });
        });
      },
      {
        rootMargin: "300px 0px",
      }
    );

    observer.observe(sentinel);
  };

  init();
};
